import { MenuItem, SelectProps, Stack } from "@mui/material";
import { DownChevronIcon } from "Assets/icons/chevron.icon";
import { BaseSelect, BelowChips } from "Components/Input";
import { SmText } from "Components/Text";
import {Fragment} from 'react'

const BelowSelect = (
  props: SelectProps & {
    toplabel?: string;
    customValue?: any[];
    options?: any[];
    showBelow?: boolean;
    onDeleteSelect?: (value: string | number) => void;
    requiredlabel?: boolean;
  }
) => {
  const {
    placeholder,
    showBelow = true,
    customValue,
    options,
    onDeleteSelect = () => {},
    toplabel,
    requiredlabel,
  } = props;

  const Common = () => (
    <BaseSelect
      displayEmpty
      renderValue={() => (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <span className="placeholder">{placeholder}</span>
        </div>
      )}
      defaultValue={[]}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 360,
          },
        },
      }}
      IconComponent={DownChevronIcon}
      {...props}
    >
      {options?.map((option, i) => (
        <MenuItem key={i} value={option.value}>
          {option?.label}
        </MenuItem>
      ))}
    </BaseSelect>
  );

  return (
    <Stack spacing={1}>
      {!toplabel && <Common />}

      {toplabel && (
        <Fragment>
          <SmText
            className={"input-label " + (requiredlabel ? " required" : "")}
          >
            {toplabel}
          </SmText>
          <Common />
        </Fragment>
      )}

      {showBelow && (
        <BelowChips {...{ options, customValue, onDeleteSelect }} />
      )}
    </Stack>
  );
};

export default BelowSelect;
